import Err from '../../models/err';

export default function createTakenError(attrName, attrs = {}) {
  return new Err({ code: Err.Code.TAKEN, attr: attrName, detail: `${attrName} is already taken`, ...attrs });
}



// WEBPACK FOOTER //
// ./src/scripts/domain/factories/error/create_taken_error.js